// Clairova Theme v5 — JavaScript
(function() {
  'use strict';

  // Mobile menu toggle
  const toggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function() {
      mobileNav.classList.toggle('active');
      const isOpen = mobileNav.classList.contains('active');
      toggle.setAttribute('aria-expanded', isOpen);
    });

    // Close mobile nav when a link is clicked
    mobileNav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileNav.classList.remove('active');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Announcement bar close persistence
  const announcementBar = document.getElementById('announcement-bar');
  if (announcementBar) {
    const dismissed = sessionStorage.getItem('announcement-dismissed');
    if (dismissed === 'true') {
      announcementBar.style.display = 'none';
    }
    const closeBtn = announcementBar.querySelector('.announcement-bar__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        announcementBar.style.display = 'none';
        sessionStorage.setItem('announcement-dismissed', 'true');
      });
    }
  }
})();
